import React from 'react';
import { ModalProvider } from './src/contexts/ModalContext';
import { AppWrapper } from './src/components/AppWrapper';
import { captureUtmFromUrl } from './src/utils/utm';
import './src/index.css';

export const onRouteUpdate = () => {
  captureUtmFromUrl();
};

export const wrapRootElement = ({ element }) => {
  return <ModalProvider>{element}</ModalProvider>;
};

export const wrapPageElement = ({ element }) => {
  return <AppWrapper>{element}</AppWrapper>;
};
